import {Get, Post, Put, Patch, Delete} from 'skytech-request'

export {
    Get,
    Post,
    Put,
    Patch,
    Delete
}
